export const companiesTableColumns = [
  {
    prop: 'is_active',
    title: 'common.filters.active',
    width: '6%',
    sortingEnabled: true,
  },
  {
    prop: 'fullname',
    title: 'common.fields.full_name',
    width: '37.77%',
    sortingEnabled: true,
  },
  {
    prop: 'short_name',
    title: 'common.fields.short_name',
    width: '18.06%',
    sortingEnabled: true,
  },
  {
    prop: 'client_companies_length',
    title: 'adm.companies.company_dialog.client_companies',
    width: '12.24%',
    sortingEnabled: true,
  },
  {
    prop: 'contacts',
    title: 'common.fields.contacts',
    width: '13.24%',
    sortingEnabled: true,
  },
  {
    prop: 'address_city',
    title: 'adm.companies.company_dialog.city',
    width: '3.62%',
    sortingEnabled: true,
  },
  {
    prop: 'actions',
    title: 'common.fields.actions',
    width: '9.07%',
    sortingEnabled: false,
  },
];
